import EnumSet from 'Services/enumSet'

interface IChatMessageTypes extends EnumSet {
 none: number
 message: number
 budget: number
}

const categoryOrder = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  message: { value: 1, description: 'Mensagem' },
  budget: { value: 2, description: 'Orcamento' },
}) as IChatMessageTypes

export default categoryOrder